// mobile-first — sm~xl 은 「그 폭 이상」(min-only), xs 만 모바일 전용(max-only). matchMedia 가 이 값을 쓰고, globals.css 의 @custom-variant·@theme 폭도 이 값과 같아야 한다.
export const SCREENS = {
  xs: { max: "375.98px" },
  sm: { min: "376px" },
  md: { min: "641px" },
  lg: { min: "1025px" },
  xl: { min: "1441px" },
} as const;
